import { useState } from 'react'
import { Typography } from '@mui/material'
import TokTokDocDialog from '../../Common/Dialog'
import { useAppDispatch } from '../../../store'
import { displaySnackbar } from '../../../actions/main'
import { DeleteBackgroundIcon } from '../../../assets/icons/icons'
import useStyles from '../plannedExpertiseCard/_styles'
import { PlannedExpertiseAbandonDialogProps } from './_props'
import { tanstackQueryClient } from '../../../api/tanstackClient'
import useCurrentHcs from '../../../hooks/useCurrentHcs'
import {
    useDeleteIdsHealthcareservicesHcsIdTransmissionsTransmissionId,
} from '@toktokdoctech/tokapi-client'

const PlannedExpertiseAbandonDialog = ({
    isOpen,
    onClose,
    onConfirm,
    transmissionId,
    mode,
}: PlannedExpertiseAbandonDialogProps) => {
    const dispatch = useAppDispatch()
    const classes = useStyles()
    const [isAbandonLoading, setIsAbandonLoading] = useState(false)
    const currentHcs = useCurrentHcs()
    const { mutateAsync: deleteTransmission } = useDeleteIdsHealthcareservicesHcsIdTransmissionsTransmissionId()

    const handleAbandon = async () => {
        setIsAbandonLoading(true)
        try {
            if (mode === 'workflow') {
                if (!currentHcs?.id) {
                    throw new Error('HCS introuvable')
                }
                if (!transmissionId) {
                    throw new Error('ID téléexpertise introuvable')
                }
                await deleteTransmission({
                    hcsId: currentHcs.id,
                    transmissionId,
                })
                tanstackQueryClient.invalidateQueries({
                    queryKey: [`/ids/healthcareservices/${currentHcs.id}/transmissions`],
                    exact: false,
                })
            }
            dispatch(
                displaySnackbar(
                    'success',
                    'La téléexpertise a bien été supprimée',
                    undefined,
                    '[PlannedExpertiseAbandonDialog] abandon téléexpertise',
                ),
            )
            onConfirm()
        } catch (error: any) {
            dispatch(
                displaySnackbar(
                    'error',
                    error?.message ?? 'Une erreur est survenue pendant l\'abandon de la téléexpertise',
                    undefined,
                    '[PlannedExpertiseAbandonDialog] error abandon téléexpertise',
                ),
            )
        } finally {
            setIsAbandonLoading(false)
            onClose()
        }
    }

    return (
        <TokTokDocDialog
            isOpen={isOpen}
            handleClose={onClose}
            handleSave={handleAbandon}
            handleCancel={onClose}
            saveTitle="Supprimer"
            title="Êtes-vous sûr de vouloir abandonner la téléexpertise ?"
            loading={isAbandonLoading}
            disableEscape={false}
            isDeleteAction
            dialogProps={{
                fullScreen: false,
                disableScrollLock: false,
                PaperProps: {
                    className: classes.dialogPaperNoScroll,
                    style: { overflow: 'hidden' },
                },
                slotProps: {
                    backdrop: {
                        className: classes.PlannedExpertisePopUpDeleteBackdrop,
                    },
                },
            }}
        >
            <Typography className={classes.PlannedExpertisePopUpDelete}>
                En poursuivant, la téléexpertise sera définitivement supprimée
            </Typography>
            <DeleteBackgroundIcon />
        </TokTokDocDialog>
    )
}

export default PlannedExpertiseAbandonDialog


